var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPortal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.881,
    height: 91.477,
    viewBox: "0 0 138.881 91.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_2",
    x: 0,
    y: 0,
    width: 80.481,
    height: 91.477,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_10434",
    x: 52.167,
    y: 61.035,
    width: 86.714,
    height: 30.172,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Glucroft_Portal_Logo_v2",
    "data-name": "Glucroft Portal Logo_v2",
    transform: "translate(9 11.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -11.96)",
    filter: "url(#Union_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2-2",
    "data-name": "Union 2",
    d: "M39.273,67.522,39.23,41.866l1.718-1.718.022-6.2a19.9,19.9,0,0,1-12.347-5.523,14.411,14.411,0,0,0-8.915-2.816C11.284,25.613,5.2,31.489,5.2,39.6c0,8.008,6.084,13.988,14.456,13.988a15.405,15.405,0,0,0,8.528-2.34V39.393h4.991v14.2A21.51,21.51,0,0,1,19.4,58.217C8.216,58.217,0,50.365,0,39.6S8.216,20.985,19.5,20.985a23.288,23.288,0,0,1,4.4.4A20.01,20.01,0,1,1,44.014,33.952l.022,6.2,1.717,1.718V67.522ZM32.707,4.248A13.82,13.82,0,1,0,42.492.187,13.821,13.821,0,0,0,32.707,4.248Z",
    transform: "translate(9 11.96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -11.96)",
    filter: "url(#Path_10434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10434-2",
    "data-name": "Path 10434",
    d: "M6.426-11.9H1.785V0h1.7V-3.6H6.426c3.094,0,4.964-1.564,4.964-4.148S9.52-11.9,6.426-11.9ZM6.375-5.083H3.485v-5.338h2.89c2.176,0,3.315.969,3.315,2.669S8.551-5.083,6.375-5.083ZM19.431.136A6.029,6.029,0,0,0,25.738-5.95a6.029,6.029,0,0,0-6.307-6.086A6.048,6.048,0,0,0,13.09-5.95,6.048,6.048,0,0,0,19.431.136Zm0-1.513A4.476,4.476,0,0,1,14.79-5.95a4.476,4.476,0,0,1,4.641-4.573A4.468,4.468,0,0,1,24.038-5.95,4.468,4.468,0,0,1,19.431-1.377ZM38.148,0,35.326-3.995a3.755,3.755,0,0,0,2.618-3.757c0-2.584-1.87-4.148-4.964-4.148H28.339V0h1.7V-3.621H32.98c.255,0,.51-.017.748-.034L36.3,0ZM32.929-5.066h-2.89v-5.355h2.89c2.176,0,3.315.969,3.315,2.669S35.105-5.066,32.929-5.066ZM42.891,0h1.683V-10.421h4.08V-11.9H38.811v1.479h4.08ZM58.8,0h1.785L55.182-11.9H53.5L48.11,0h1.751L51.17-2.975h6.324ZM51.765-4.335l2.567-5.831L56.9-4.335ZM62.356,0H70.5V-1.479H64.056V-11.9h-1.7Z",
    transform: "translate(59.38 79.07)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPortal);
export default __webpack_public_path__ + "static/media/logo-portal.b9e54becec81ac2447cd8f38a240e1e6.svg";
export { ForwardRef as ReactComponent };